var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr'),_c('h3',[_vm._v("Patterns")]),_c('div',{staticClass:"pattern-swatches"},_vm._l((_vm.patterns),function(pattern){return _c('PatternSwatch',{key:pattern.id,attrs:{"pattern":pattern}})}),1),_c('button',{staticClass:"block-button",on:{"click":_vm.modal}},[_vm._v(" Pick Pattern ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }